/* PATCHA — Mobile promo code helper for the cart drawer.
   - Persists the code in sessionStorage + localStorage + cookie.
   - Hydrates [data-patcha-cart-discount] blocks on init and on cart/drawer refresh.
   - Intercepts checkout clicks ONLY when a code is set, redirects to
     /discount/CODE?redirect=/checkout. Otherwise the existing checkout flow
     is untouched (no e.preventDefault, no e.stopPropagation).
   - Designed to be safe alongside Shopify analytics, GTM/Meta/TikTok pixels,
     Klaviyo, Hulk Discounts, ReelUp, Trustoo, SweepWidget.
*/
(function () {
  if (window.__patchaCartDiscountInit) return;
  window.__patchaCartDiscountInit = true;

  var STORAGE_KEY = 'patcha_discount_code';
  var COOKIE_NAME = 'patcha_discount_code';
  var COOKIE_MAX_AGE = 60 * 60 * 24 * 7;

  function cleanCode(value) {
    return String(value == null ? '' : value)
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '')
      .replace(/[^A-Z0-9_-]/g, '');
  }

  function saveCode(code) {
    if (!code) return;
    try { window.localStorage.setItem(STORAGE_KEY, code); } catch (e) {}
    try { window.sessionStorage.setItem(STORAGE_KEY, code); } catch (e) {}
    try {
      document.cookie =
        COOKIE_NAME + '=' + encodeURIComponent(code) +
        '; path=/; max-age=' + COOKIE_MAX_AGE + '; SameSite=Lax';
    } catch (e) {}
  }

  function readCookie() {
    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return '';
    try { return decodeURIComponent(match[1]); } catch (e) { return ''; }
  }

  function getCode() {
    var v = '';
    try { v = window.sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) {}
    if (!v) { try { v = window.localStorage.getItem(STORAGE_KEY) || ''; } catch (e) {} }
    if (!v) v = readCookie();
    return cleanCode(v);
  }

  function clearCode() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
    try { document.cookie = COOKIE_NAME + '=; path=/; max-age=0; SameSite=Lax'; } catch (e) {}
  }

  function setMessage(el, text, color) {
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
    if (color) el.style.color = color;
  }

  function hideMessage(el) {
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
  }

  function syncHiddenInputs() {
    var code = getCode();
    var inputs = document.querySelectorAll('input[name="discount"][data-patcha-discount-hidden]');
    for (var i = 0; i < inputs.length; i++) inputs[i].value = code;
  }

  function applyUI(root) {
    if (!root || root.getAttribute('data-patcha-discount-ready') === 'true') return;

    var input = root.querySelector('[data-patcha-discount-input]');
    var button = root.querySelector('[data-patcha-discount-apply]');
    var message = root.querySelector('[data-patcha-discount-message]');
    var hidden = root.querySelector('[data-patcha-discount-hidden]');

    var existing = getCode();
    if (existing) {
      if (input) input.value = existing;
      if (hidden) hidden.value = existing;
      setMessage(message, 'Code : ' + existing + ' — cliquez sur commander pour appliquer la remise', '#138a44');
    }

    if (button && input) {
      button.addEventListener('click', function () {
        var code = cleanCode(input.value);
        if (!code) {
          setMessage(message, 'Ajoutez un code promo valide.', '#c2410c');
          return;
        }
        input.value = code;
        if (hidden) hidden.value = code;
        saveCode(code);
        syncHiddenInputs();
        setMessage(message, 'Code : ' + code + ' — cliquez sur commander pour appliquer la remise', '#138a44');
      });
    }

    if (input) {
      input.addEventListener('input', function () {
        var raw = input.value;
        var cleaned = cleanCode(raw);
        if (raw !== cleaned) input.value = cleaned;
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (button) button.click();
        }
      });
    }

    root.setAttribute('data-patcha-discount-ready', 'true');
  }

  function isCheckoutTarget(target) {
    if (!target) return false;
    if (target.name === 'checkout') return true;
    var href = target.getAttribute && target.getAttribute('href');
    if (href && href.indexOf('/checkout') === 0) return true;
    if (target.id === 'CartDrawer-Checkout') return true;
    if (target.id === 'checkout' || target.id === 'checkout-button') return true;
    if (target.classList && (target.classList.contains('btn-checkout') || target.classList.contains('cart__checkout-button'))) return true;
    return false;
  }

  function buildDiscountUrl(code) {
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
  }

  function enhanceCheckoutButtons() {
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      var path = event.composedPath ? event.composedPath() : [event.target];
      var target = null;
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (!node || node.nodeType !== 1) continue;
        if (isCheckoutTarget(node)) { target = node; break; }
        if (node.matches && node.matches('button, a, input[type="submit"]') && isCheckoutTarget(node)) {
          target = node;
          break;
        }
      }
      if (!target) return;

      var code = getCode();
      if (!code) return;

      event.preventDefault();
      event.stopPropagation();
      window.location.href = buildDiscountUrl(code);
    }, true);
  }

  function hydrateAll() {
    var blocks = document.querySelectorAll('[data-patcha-cart-discount]');
    for (var i = 0; i < blocks.length; i++) applyUI(blocks[i]);
    syncHiddenInputs();
  }

  function init() {
    hydrateAll();
    enhanceCheckoutButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('cart:updated', hydrateAll);
  document.addEventListener('cart-drawer:open', hydrateAll);
  document.addEventListener('cart:refresh', hydrateAll);

  /* Re-hydrate after cart drawer is re-rendered (AJAX cart-drawer update). */
  var rehydrateScheduled = false;
  function scheduleRehydrate() {
    if (rehydrateScheduled) return;
    rehydrateScheduled = true;
    var ric = window.requestIdleCallback || function (cb) { return setTimeout(cb, 50); };
    ric(function () {
      rehydrateScheduled = false;
      hydrateAll();
    });
  }

  try {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && (node.matches('[data-patcha-cart-discount]') || node.querySelector && node.querySelector('[data-patcha-cart-discount]'))) {
            scheduleRehydrate();
            return;
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
